import { render, staticRenderFns } from "./ProjectSummaryDialog.vue?vue&type=template&id=34905660"
import script from "./ProjectSummaryDialog.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryDialog.vue?vue&type=script&lang=js"
import style0 from "./ProjectSummaryDialog.vue?vue&type=style&index=0&id=34905660&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports